import React from "react";
import { StatusPill } from "@/components/StatusPill";

export const Hero = ({ katlas }) => {
    return (
        <header className="border-b hairline">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8 flex items-start justify-between gap-6">
                <div className="flex items-center gap-3">
                    <div
                        className="h-7 w-7 border border-[var(--ink)] flex items-center justify-center"
                        style={{ background: "var(--ink)" }}
                    >
                        <span
                            className="font-serif"
                            style={{ color: "#fff", fontSize: 16, lineHeight: 1 }}
                        >
                            H
                        </span>
                    </div>
                    <div className="flex flex-col leading-tight">
                        <span className="font-serif" style={{ fontSize: 18 }}>
                            HealthCierge
                        </span>
                        <span className="mono-label" style={{ fontSize: 9.5 }}>
                            KATLAS · Cierge demonstrator
                        </span>
                    </div>
                </div>
                <StatusPill status={katlas?.status} label={katlas?.label} />
            </div>

            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-10 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-8">
                    <p className="mono-label mb-6">
                        Cardiovascular patient journey governance — v1
                    </p>
                    <h1
                        className="font-serif tracking-tight"
                        style={{
                            fontSize: "clamp(40px, 6.4vw, 84px)",
                            lineHeight: 0.98,
                            letterSpacing: "-0.02em",
                            color: "var(--ink)",
                        }}
                    >
                        Patient consents.
                        <br />
                        AI supports.
                        <br />
                        <span style={{ color: "var(--forest)" }}>
                            Authorised health roles
                        </span>{" "}
                        decide.
                        <br />
                        KATLAS signs the receipt.
                    </h1>
                </div>
                <div className="lg:col-span-4 flex flex-col gap-6 lg:pl-8 lg:border-l hairline">
                    <p
                        className="font-serif"
                        style={{
                            fontSize: 17,
                            lineHeight: 1.55,
                            color: "var(--ink-soft)",
                        }}
                    >
                        HealthCierge coordinates cardiovascular journeys across
                        patients, clinicians, pharmacists, researchers and certified
                        community health coaches. Evidence stays under patient or
                        role custody; requests are purpose-bound; authorised roles
                        decide; KATLAS receipts prove what was shared, what was
                        withheld and what action followed.
                    </p>
                    <div className="border-t hairline pt-4">
                        <p className="mono-label mb-1">Operating grammar</p>
                        <p className="font-serif" style={{ fontSize: 14 }}>
                            <span className="font-mono uppercase tracking-widest text-xs">
                                C
                            </span>
                            ustody &nbsp;·&nbsp;
                            <span className="font-mono uppercase tracking-widest text-xs">
                                A
                            </span>
                            uthority &nbsp;·&nbsp;
                            <span className="font-mono uppercase tracking-widest text-xs">
                                R
                            </span>
                            eceipts
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Hero;
